import styles from './Total.css'
import {rupiah} from 'utils/formatter'

class ReceiptTotal extends React.Component {
  render () {
    let {invoiceDetail} = this.props

    return (
      <div className={styles['receipt-counting-box']}>
        <div className={styles['receipt-total']}>
          <div className='pull-left'>Total</div>
          <div className='pull-right'>{rupiah(invoiceDetail.total_collected)}</div>
        </div>
        {(invoiceDetail.total_amount_received !== 0) &&
          <div className={styles['amount-received']}>
            <div className='pull-left'>Amount Received</div>
            <div className='pull-right'>{rupiah(invoiceDetail.total_amount_received)}</div>
          </div>
        }
        <div className={styles['amount-due']}>
          <div className='pull-left'>Amount Due</div>
          <div className='pull-right'>{rupiah(invoiceDetail.total_amount_due)}</div>
        </div>
      </div>
    )
  }
}

ReceiptTotal.propTypes = {
  invoiceDetail: React.PropTypes.object
}

export default ReceiptTotal



// WEBPACK FOOTER //
// ./app/components/receipt/invoices/Total/ReceiptTotal.js